module.exports = __webpack_public_path__ + "img/loading.db0afca2.svg";